import { FC, useEffect, useMemo } from 'react';
import { Marker } from 'react-leaflet';

import { defaultPinIcon, searchPinIcon } from 'global/Constants/leafletIcons';
import { useSelector } from 'react-redux';
import { setMap, setMapSearchResult } from 'redux/reducer/MapReducer/mapReducer';
import { RootState, store } from 'redux/store';

type pinv2 = {
  Text: string;
  Title: string;
  Address: string;
  Province: string;
  City: string;
  Type: string;
  FClass: string;
  Coordinate: {
    lat: number;
    lon: number;
  };
};

interface IProps {
  setSelectedLocation?: (_latlng: { lat: number; lng: number }) => void;
  selectedLocation?: { lat: number; lng: number };
}
const TcMapSearchResults: FC<IProps> = ({ setSelectedLocation, selectedLocation }) => {
  //states
  const { searchResults, map } = useSelector((state: RootState) => state.map);

  //hook
  useEffect(() => {
    map?.on('click', (e: any) => setSelectedLocation && setSelectedLocation(e.latlng), store.dispatch(setMapSearchResult(undefined)));
    setMap && !!map && store.dispatch(setMap(map));
  }, [map]);

  //func
  const renderPins = useMemo(() => {
    //show selected place

    const result = searchResults as pinv2[];
    const pinResult = (
      <>
        {selectedLocation && <Marker position={[selectedLocation.lat, selectedLocation.lng]} icon={defaultPinIcon} />}
        {result?.map((pin) => {
          return <Marker key={pin.Coordinate.lat + pin.Coordinate.lon} position={[pin.Coordinate.lat, pin.Coordinate.lon]} icon={searchPinIcon} />;
        })}
      </>
    );

    return pinResult;
  }, [searchResults, selectedLocation]);

  return <>{renderPins}</>;
};

export default TcMapSearchResults;
